import { route } from '@/route-map';

// Export the route function for use in components
export function useRoute() {
    return route;
}